import AppConstants from "../config/app.constants";

let BillingRecordsService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/billing-records`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let getBillableCustomer = (searchText, currentStat, offset, limit, startDate, endDate, branchId, billableEvents, billingCategory, customer) => {
        return $http
            .get(AppConstants.api + `/billing-records/get-billable-customer`, {
                params: {
                    searchText,
                    currentStat,
                    offset,
                    limit,
                    startDate,
                    endDate,
                    branchId,
                    billableEvents,
                    billingCategory,
                    customer
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let getBillingRecords = (searchText, customerId, sortASC, sortColumn, currentStat, offset, limit, startDate, endDate, branchId, billableEvents, billingCategory, customer) => {
        return $http
            .get(AppConstants.api + `/billing-records/get-billing-records`, {
                params: {
                    searchText,
                    customerId,
                    sortASC,
                    sortColumn,
                    currentStat,
                    offset,
                    limit,
                    startDate,
                    endDate,
                    branchId,
                    billableEvents,
                    billingCategory,
                    customer
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let approveBillingRecords = (billingRecords, userId, isApproveAllRecords, startDate, endDate, customerId, locationId, billingCategoryId) => {
        return $http
            .post(AppConstants.api + `/billing-records/approve-billing-records`, {
                billingRecords,
                userId,
                isApproveAllRecords,
                startDate,
                endDate,
                customerId,
                locationId,
                billingCategoryId
            })
            .then((res) => {
                return res.data
            })
    }

    let surchargePreview = (billingRecordIds, isApproveAllRecords, startDate, endDate, customerId, locationId, billingCategoryId) => {
        return $http
            .post(AppConstants.api + `/billing-records/surcharge-preview`, {
                billingRecordIds,
                isApproveAllRecords,
                startDate,
                endDate,
                customerId,
                locationId,
                billingCategoryId
            })
            .then((res) => {
                return res.data
            })
    }

    let updateBillingRecords = (billingRecordId, rate, amountDue, branchId, billingCategory, billingType, locationId,
        customerId, status, startDate, endDate, isApproved, userId, searchText, selectedBillingCategoryId,selectedCustomerId, selectedBillableEvent, billableEventId, billableEvent) => {
        return $http
            .post(AppConstants.api + `/billing-records/update-billing-records`, {
                billingRecordId,
                rate,
                amountDue,
                branchId,
                billingCategory,
                billingType,
                status,
                customerId,
                locationId,
                startDate,
                endDate,
                isApproved,
                userId,
                searchText,
                selectedBillingCategoryId,
                selectedCustomerId,
                selectedBillableEvent,
                billableEventId,
                billableEvent
            })
            .then((res) => {
                return res.data
            })
    }

    let billableEventLogDetails = (searchText, entryType, branchId, startDate, endDate) => {
        return $http
            .get(AppConstants.api + `/billing-records/billable-event-log-details`, {
                params: {
                    searchText,
                    entryType,
                    branchId,
                    startDate,
                    endDate
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let exportBillingReport = (startDate, endDate, currentStat, customerList, childStat, searchText, branchId, billableEvents, billingCategory, customer) => {
        return new Promise((resolve, reject) => {
            const url = AppConstants.api + `/billing-records/export-billing-report`;
            const xhr = new XMLHttpRequest();

            xhr.open("POST", url);
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhr.responseType = "arraybuffer";

            const data = {
                startDate,
                endDate,
                currentStat,
                customerList,
                childStat,
                searchText,
                branchId,
                billableEvents,
                billingCategory,
                customer
            }

            xhr.onload = function () {
                if (this.status === 200) {
                    const blob = new Blob([xhr.response], { type: "application/xlsx" });
                    const a = document.createElement('a');
                    const reportPrefix = 'Billing_Approval';
                    const date = moment.utc(startDate).format('YYYY-MM-DD') + '_To_' + moment.utc(endDate).format('YYYY-MM-DD');

                    let sheetName;
                    if (currentStat == 'unassigned') {
                        sheetName = reportPrefix.concat(`_(${currentStat})_${childStat}_`, date, '.xlsx')
                    } else {
                        sheetName = reportPrefix.concat(`_(${currentStat})_`, date, '.xlsx');
                    }

                    a.href = URL.createObjectURL(blob);
                    a.download = sheetName;
                    a.click();
                    return resolve();
                }
                else {
                    return reject()
                }
            };
            xhr.send(JSON.stringify(data));
        })
    }

    let generateStaticBillingRecord = (billingEventType) => {
        return $http
            .post(AppConstants.api + `/billing-records/generate-static-billing-report`, {
                billingEventType
            })
            .then((res) => {
                return res.data
            })
    }

    let getStaticBillingEventsRecords = (staticBillingCategory, vaultDate, contractId, contractRuleId, locationId, limit, offset, currentStat) => {
        return $http
            .get(AppConstants.api + `/billing-records/get-static-billing-events-records`, {
                params: { staticBillingCategory, vaultDate, contractId, contractRuleId, locationId, limit, offset, currentStat }
            })
            .then((res) => {
                return res.data
            })
    }

    let deleteBillingRecord = (data) => {
        return $http.post(AppConstants.api + `/billing-records/delete-billing-record`, data)
            .then((res) => {
                return res.data
            })
    }

    let createPostBillingRecords = (month, contractId) => { 
        return $http.post(AppConstants.api + `/billing-records/create-post-billing-records`, { month, contractId })
            .then((res) => {
                return res.data
            })
    }

    let undoApproveBillingRecords = (data) => {
        return $http.post(AppConstants.api + `/billing-records/undo-approve-billing-records`, { data })
            .then((res) => {
                return res.data
            })
    }

    let findCustomerContractByLocation = (locationId) => {
        return $http.get(AppConstants.api + `/billing-records/find-customer-contract-by-location`, { params: { locationId } })
            .then((res) => {
                return res.data
            })
    }

    let createBillingRecords = (data) => {
        return $http.post(AppConstants.api + `/billing-records/create-billing-records`, data)
            .then((res) => {
                return res.data
            })
    }

    let manuallyCreatedBillingRecordsLog = (billingRecordId) => {
        return $http
            .get(AppConstants.api + `/billing-records/manually-created-billing-records-log`, {
                params: { billingRecordId }
            })
            .then((res) => {
                return res.data
            })
    };

    let getEventLogs = (entryType, locationId, vaultDate, branchId) => {
        return $http
            .get(AppConstants.api + `/billing-records/get-event-logs`, {
                params: { entryType, locationId, vaultDate, branchId }
            })
            .then((res) => {
                return res.data
            })
    };

    return {
        all,
        getBillableCustomer,
        getBillingRecords,
        approveBillingRecords,
        surchargePreview,
        updateBillingRecords,
        billableEventLogDetails,
        exportBillingReport,
        generateStaticBillingRecord,
        getStaticBillingEventsRecords,
        deleteBillingRecord,
        createPostBillingRecords,
        undoApproveBillingRecords,
        findCustomerContractByLocation,
        createBillingRecords,
        manuallyCreatedBillingRecordsLog,
        getEventLogs
    }
}

BillingRecordsService.$inject = ['$http', '$q']

export default BillingRecordsService;


// WEBPACK FOOTER //
// ./client/app/services/billing-records.service.js